import { useEffect, useState } from "react";
import { isAndroidApp } from "web_myplann/Utils/device";

const KEYBOARD_HEIGHT_THRESHOLD_PX = 150;

const editableSelector =
	'input:not([readonly]):not([type="checkbox"]):not([type="radio"]), textarea:not([readonly]), select, [contenteditable="true"]';

const getIsSoftKeyboardOpen = (): boolean => {
	const activeElement = document.activeElement;
	if (
		!isAndroidApp ||
		!(activeElement instanceof HTMLElement) ||
		!activeElement.matches(editableSelector)
	) {
		return false;
	}

	const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
	const keyboardThreshold = Math.min(
		KEYBOARD_HEIGHT_THRESHOLD_PX,
		window.screen.height * 0.2,
	);
	return window.screen.height - viewportHeight > keyboardThreshold;
};

export const useSoftKeyboardOpen = (active: boolean): boolean => {
	const [isSoftKeyboardOpen, setIsSoftKeyboardOpen] = useState(false);

	useEffect(() => {
		if (!active || !isAndroidApp) {
			setIsSoftKeyboardOpen(false);
			return;
		}

		const visualViewport = window.visualViewport;
		const updateKeyboardState = () => {
			setIsSoftKeyboardOpen(getIsSoftKeyboardOpen());
		};

		updateKeyboardState();
		window.addEventListener("resize", updateKeyboardState);
		document.addEventListener("focusin", updateKeyboardState);
		document.addEventListener("focusout", updateKeyboardState);
		visualViewport?.addEventListener("resize", updateKeyboardState);

		return () => {
			window.removeEventListener("resize", updateKeyboardState);
			document.removeEventListener("focusin", updateKeyboardState);
			document.removeEventListener("focusout", updateKeyboardState);
			visualViewport?.removeEventListener("resize", updateKeyboardState);
		};
	}, [active]);

	return isSoftKeyboardOpen;
};
